(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-lp-bar-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(bar) {
    var clock = bar.querySelector('[data-sf-countdown]');
    if (!clock) return;
    var end = null;
    var endAttr = (bar.dataset.countdownEnd || '').trim();
    if (endAttr) {
      var parsed = new Date(endAttr).getTime();
      if (!isNaN(parsed)) end = parsed;
    }
    var hours = parseFloat(bar.dataset.countdownHours || '0');
    if (!end && hours > 0) {
      var key = 'sf-lp-countdown';
      var stored = parseInt(window.localStorage.getItem(key) || '0', 10);
      if (!stored || stored < Date.now()) {
        stored = Date.now() + hours * 3600 * 1000;
        window.localStorage.setItem(key, String(stored));
      }
      end = stored;
    }
    if (!end) return;
    clock.hidden = false;
    var h = clock.querySelector('[data-sf-h]');
    var m = clock.querySelector('[data-sf-m]');
    var s = clock.querySelector('[data-sf-s]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var timer;
    var tick = function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      h.textContent = pad(Math.floor(left / 3600));
      m.textContent = pad(Math.floor(left / 60) % 60);
      s.textContent = pad(left % 60);
      if (left === 0 && timer) clearInterval(timer);
    };
    tick();
    timer = setInterval(tick, 1000);
  }
  document.querySelectorAll('.sf-lp-bar').forEach(boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.sf-lp-bar').forEach(boot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-lp-buy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(form) {
    var priceEl = form.querySelector('[data-sf-price]');
    if (!priceEl) return;
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'id') return;
      var card = e.target.closest('[data-price]');
      if (card) priceEl.textContent = card.dataset.price;
    });
  }
  function bootDirect(form) {
    if (form.dataset.sfDirect !== 'true') return;
    if (form.dataset.sfDirectBound) return;
    form.dataset.sfDirectBound = '1';
    form.addEventListener('submit', function (e) {
      var picked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!picked || !picked.value) return;   /* let the normal add-to-cart run */
      e.preventDefault();
      /* Cart permalink: builds the cart and lands on checkout in one hop. */
      window.location.href = '/cart/' + picked.value + ':1';
    });
  }
  document.querySelectorAll('[data-sf-buy]').forEach(boot);
  document.querySelectorAll('[data-sf-buy]').forEach(bootDirect);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sf-buy]').forEach(boot);
    e.target.querySelectorAll('[data-sf-buy]').forEach(bootDirect);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-lp-expect"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot(card) {
    var tabs = card.querySelectorAll('[data-sf-tab]');
    var panels = card.querySelectorAll('[data-sf-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-sf-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-sf-panel') === id); });
      });
    });
  }
  document.querySelectorAll('[data-sf-expect]').forEach(boot);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sf-expect]').forEach(boot);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
